<p-floatLabel>
  <p-select #periodSelector
    id="periodSelector"
    name="periodSelector"
    [options]="periods"
    [(ngModel)]="selectedPeriod"
    [showClear]="true"
    [checkmark]="true"
    [filter]="true"
    styleClass="w-100"
    [disabled]="isDisabled"
    (onChange)="onSelected()"
    optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="periodSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Period') }}
    </app-label-content>
  </label>
</p-floatLabel>